document.addEventListener('DOMContentLoaded', () => {
  $('#claim-table').DataTable({
    fixedHeader: true,
    processing: true,
    serverSide: true,
    ajax: {
      'type': 'get',
      'url': '/claims',
      'dataType': 'json',
      'data': (data) => {
        data.page = parseInt($('#claim-table').DataTable().page.info().page) + 1
        data.per_page = $('#claim-table').DataTable().page.info().length
        data.search = data.search.value
        data.order = $('#claim-table').DataTable().order()[0][0]
        data.direction = $('#claim-table').DataTable().order()[0][1]
        data.status = $('#claim-status').val()
        data.business_unit_id = $('#select-business-unit-filter').val()
      }
    },
    columnDefs: [
      {
        "bSortable": false,
        "aTargets": [ 7 ]
      }
    ]
  });
});

$(document).on('dp.change', '#claims-from-filter, #claims-to-filter', () => { filter_claims() });
$(document).on('change.select2', '#claim-type, #claim-status, #select-business-unit-filter', () => { filter_claims() });
$(document).on('click', '#export-claims-csv-btn', (e) => { export_claims_csv(e) });

const claim_filters = () => {
  const claim_type_ids = $('#claim-type').val();
  const status = $('#claim-status').val();
  const business_unit_id = $('#select-business-unit-filter').val();
  const pathname = window.location.pathname;
  const employee_id = pathname.split('/')[1] === 'employees' ? pathname.split('/')[2] : null;
  const from = $('#claims-from-filter').val();
  const to = $('#claims-to-filter').val();
  const table = $.fn.DataTable.isDataTable('#claim-table') ? $('#claim-table').DataTable() : null;

  return {
    claim_type: claim_type_ids,
    status: status,
    business_unit_id: business_unit_id,
    employee_id: employee_id,
    from: from,
    to: to,
    search: table ? table.search() : ''
  };
}

const filter_claims = () => {
  let pathname = window.location.pathname;
  let employee_id = pathname.split('/')[2];
  const filters = claim_filters();

  if (pathname.split('/')[1] == 'claims'|| ((pathname.split('/')[1] == 'employees') && employee_id)) {
    $.ajax({
      type: 'GET',
      url: '/claims',
      dataType: 'script',
      data: filters
    });
  }
}

const export_claims_csv = (e) => {
  e.preventDefault();

  $.ajax({
    type: 'POST',
    url: $(e.currentTarget).data('url'),
    dataType: 'json',
    headers: { 'X-CSRF-Token': $('meta[name=csrf-token]').attr('content') },
    data: claim_filters(),
    success: (response) => {
      append_success_message_in_alert_container(response.message);
      $('html').scrollTop(0);
    },
    error: (xhr) => {
      const message = xhr.responseJSON?.message || 'Unable to generate claims CSV.';
      append_errors_list_in_alert_container([message]);
      $('html').scrollTop(0);
    }
  });
}
